import React from 'react';

import { Image } from 'antd';

import styles from '../FileViewer.module.css';

type ImageViewerProps = {
  url: string;
  alt?: string;
};

export const ImageViewer: React.FC<ImageViewerProps> = ({ url, alt }) => {
  return (
    <div className={styles.imageContainer}>
      <Image
        src={url}
        alt={alt || 'Artifact Image'}
        wrapperClassName={styles.imageWrapper}
        className={styles.image}
        preview={false}
      />
    </div>
  );
};
